import { useScreen } from "../context/ScreenContext";
import { ChoiceToggle, DateInput, LabelInput } from "./Inputs";

const PlayerForm = ({ handleChange, index, maxDate }) => {

    const {isSmallScreen} = useScreen()

    return ( 
        <div
            key={index}
            style={{
                borderRadius: "4px",
                boxShadow: "1px 2px 2px gray, -1px 2px 2px gray",
                margin: 5,
                padding: 5,
                width: "100%",
                display: "flex",
                flexDirection: isSmallScreen ? "row" : "column",
                flexWrap: isSmallScreen ? "wrap" : "wrap",
                justifyContent: isSmallScreen ? "space-between" : "center",
                gap: "1rem",
            }}
            >
            <label style={{ fontSize: 18 }}>Joueur {index + 1}</label>
            <LabelInput
                index={index}
                label={"Nom"}
                name={"surname"}
                onChange={handleChange}
                placeholder={""}
                type={"text"}
            />
            <LabelInput
                index={index}
                label={"Prénom"}
                name={"firstname"}
                onChange={handleChange}
                placeholder={""}
                type={"text"}
            />
            <LabelInput
                index={index}
                label={"Nom de naissance"}
                name={"birthName"}
                onChange={handleChange}
                placeholder={""}
                type={"text"}
                // disabled={p.sex === "Homme"}
            />
            <LabelInput
                index={index}
                label={"Adresse"}
                name={"adress"}
                onChange={handleChange}
                placeholder={"Code postal et lieu de résidence"}
                type={"text"}
            />
            <div
                style={{
                display: "flex",
                flexFlow: "row wrap",
                justifyContent: "center",
                gap: "1rem",
                }}
            >
                <DateInput
                    handleChange={handleChange}
                    index={index}
                    label={"Date de naissance"}
                    name={"birthDate"}
                    maxDate={maxDate ? maxDate : null}
                />
                <ChoiceToggle
                option1={"femme"}
                option2={"homme"}
                onChange={handleChange}
                index={index}
                name={"sex"}
                />
                <ChoiceToggle
                label={"Licencié.e"}
                option1={"oui"}
                option2={"non"}
                onChange={handleChange}
                index={index}
                name={"licensed"}
                />
            </div>
        </div>
     );
}
 
export default PlayerForm;